import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

import FieldRepeaterCFormik from './FieldRepeaterCFormik';

const FieldRepeaterCContacts = (props) => {
	const repeatShape = { text: '', type: null };

	const linesConvertor = (name) => (option, i) => {
		return {
			props: {
				type: FORM_LINE_TYPES.typed,
				connected: true,
				params: {
					name: `${name}.${i}`,
					textfield: {
						autoFocus: option?.autoFocus,
					},
					autocomplete: {
						options: [
							{ label: 'Личный', value: 'personal' },
							{ label: 'Рабочий', value: 'work' },
						],
					},
				},
			},
		};
	};

	return (
		<FieldRepeaterCFormik
			repeatShape={repeatShape}
			linesConvertor={linesConvertor}
			{...props}
		/>
	);
};

export default FieldRepeaterCContacts;
